import { render, staticRenderFns } from "./CholesterolCreation.vue?vue&type=template&id=1bb54cda&scoped=true"
import script from "./CholesterolCreation.vue?vue&type=script&lang=js"
export * from "./CholesterolCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb54cda",
  null
  
)

export default component.exports